export const SCHEDULE_VIEW_MODE = {
  READ: 'read',
  EDIT: 'edit',
};

export const SCHEDULE_TYPES = {
  WORK: 'work',
  BLOCK: 'block',
  APPOINTMENT: 'appointment',
};
export const POPOVER_WIDTH = 320;
export const MINUTES_IN_CELL = 15;
export const CELL_HEIGHT = 22;
export const ONE_MIN_OFFSET = MINUTES_IN_CELL / CELL_HEIGHT;

export const RECURSION_OPTIONS = {
  CURRENT_DAY: 'current-day',
  CURRENT_AND_NEXT: 'current-and-next',
  ALL_DAYS: 'all-days',
  UPDATE_CUSTOM_FOLOWING: 'update-repeat-folowing',
  UPDATE_CUSTOM_ALL: 'update-repeat-all',
  NO_REPEAT_FOLOWING: 'no-repeat-folowing',
  NO_REPEAT_ALL: 'no-repeat-all',
};

export const RECURSION_MODAL_TYPES = {
  EDIT_WORK_SLOT: 'edit-work-slot',
  EDIT_BLOCK_SLOT: 'edit-block-slot',
  REMOVE_WORK_SLOT: 'remove-work-slot',
  REMOVE_BLOCK_SLOT: 'remove-block-slot',
};

export const WEEK_DAYS = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const REPEATABLE_VALUES = {
  NO_REPEAT: '',
  WEEKLY: 'weekly',
  CUSTOM: 'custom',
};

export const CHANGE_REPEAT_FLOW_TYPES = {
  DEFAULT: '',
  NO_REPEAT: 'no-repet',
  UPDATE_CUSTOM_REPEAT: 'update-custom-repeat',
};

// NO_REPEAT:::
// following days ==> remove [next-date, endOn with repeat days];
// all days ==> remove all (insert actual)



// WEBPACK FOOTER //
// ./src/components/ProviderCalendar/constants.js